import { render, staticRenderFns } from "./RegionImages.vue?vue&type=template&id=ace28968&scoped=true&"
import script from "./RegionImages.vue?vue&type=script&lang=js&"
export * from "./RegionImages.vue?vue&type=script&lang=js&"
import style0 from "./RegionImages.vue?vue&type=style&index=0&id=ace28968&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace28968",
  null
  
)

export default component.exports